/**
 * Custom Info Panel Template
 */

import { escapeHtml, createBlockWrapper } from '../utils';
import { applyThemeOverrides, getNestedValue, formatFieldLabel } from './utils';
import type { InfoPanelSection, TemplateRenderer } from './types';

export const renderCustomInfoPanel: TemplateRenderer = (
  config,
  data,
  container,
  _onAction,
  themeOverrides
) => {
  const title = config.title as string | undefined;
  const sections = (config.sections as InfoPanelSection[]) || [];
  const layout = (config.layout as string) || 'vertical';

  const wrapper = createBlockWrapper('custom-info-panel');
  applyThemeOverrides(wrapper, themeOverrides);

  if (title) {
    const titleEl = document.createElement('div');
    titleEl.className = 'pms-info-panel-title';
    titleEl.textContent = title;
    wrapper.appendChild(titleEl);
  }

  for (const section of sections) {
    const sectionEl = document.createElement('div');
    sectionEl.className = `pms-info-section pms-info-section-${layout}`;

    if (section.heading) {
      const headingEl = document.createElement('div');
      headingEl.className = 'pms-info-section-heading';
      headingEl.textContent = section.heading;
      sectionEl.appendChild(headingEl);
    }

    const fieldsEl = document.createElement('div');
    fieldsEl.className = 'pms-info-fields';

    for (const fieldKey of section.fields) {
      const value = getNestedValue(data, fieldKey);
      if (value === undefined || value === null) continue;

      const fieldEl = document.createElement('div');
      fieldEl.className = 'pms-info-field';
      fieldEl.innerHTML = `
        <span class="pms-info-field-label">${escapeHtml(formatFieldLabel(fieldKey))}</span>
        <span class="pms-info-field-value">${escapeHtml(String(value))}</span>
      `;
      fieldsEl.appendChild(fieldEl);
    }

    sectionEl.appendChild(fieldsEl);
    wrapper.appendChild(sectionEl);
  }

  container.appendChild(wrapper);
};
